import React from 'react';
import './LightPoint.css';
import Desligado from "../../assets/img/Desligado.png";

const LightPoint = ({
  id,
  x,
  y,
  width,
  height,
  circleNumber,
  descricao,
  isSelected = false,
  onClick,
  onDelete,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.(id);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete?.(id);
  };

  return (
    <div
      className={`light-point ${isSelected ? 'selected' : ''} point-light-group`}
      style={{
        left: `${x}%`,
        top: `${y}%`,
        width: `${width}%`,
        height: `${height}%`,
        position: 'absolute',
        zIndex: 5,
      }}
      onClick={handleClick}
    >
      <div className="light-container">
        <img className="imageLuz" src={Desligado} alt={descricao} />
        {circleNumber && (
          <div className="circle-overlay">
            <div className="light-number light-number-off">
              {circleNumber}
            </div>
          </div>
        )}
      </div>

      {isSelected && (
        <button className="delete-btn" onClick={handleDelete} title="Remover ponto">
          ×
        </button>
      )}
    </div>
  );
};

export default LightPoint;
